// Single source of truth for the API token. Kept in localStorage (not memory
// or sessionStorage) so reloads and new tabs share one session; other tabs
// pick up changes through the `storage` event (see http.js).
export const TOKEN_KEY = "token";
export const EXPIRES_AT_KEY = "token_expires_at";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getExpiresAt() {
  const value = parseInt(localStorage.getItem(EXPIRES_AT_KEY), 10);
  return Number.isFinite(value) ? value : null;
}

// True when the stored expiry has passed (or will within `skewMs`). A token
// saved before expiresAt was tracked has no expiry; the server's 401 decides.
export function isTokenExpired(skewMs = 0) {
  const expiresAt = getExpiresAt();
  return expiresAt !== null && Date.now() + skewMs >= expiresAt;
}

// `expiresIn` is the API's expires_in, in seconds. Never hardcode a lifetime.
export function saveSession(token, expiresIn) {
  localStorage.setItem(TOKEN_KEY, token);
  const seconds = Number(expiresIn);
  if (Number.isFinite(seconds) && seconds > 0) {
    localStorage.setItem(EXPIRES_AT_KEY, String(Date.now() + seconds * 1000));
  } else {
    localStorage.removeItem(EXPIRES_AT_KEY);
  }
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXPIRES_AT_KEY);
}
